const rankingItems = [
  { rank: 1, title: '鬼灭之刃 无限城篇', type: '日漫', hot: '🔥 3250万', change: 'up' },
  { rank: 2, title: '斗罗大陆2 绝世唐门', type: '国漫', hot: '🔥 2980万', change: 'up' },
  { rank: 3, title: '我独自升级 第二季', type: '韩漫改编', hot: '🔥 2610万', change: 'up' },
  { rank: 4, title: '葬送的芙莉莲', type: '日漫', hot: '🔥 2340万', change: 'same' },
  { rank: 5, title: '完美世界 年番', type: '国漫', hot: '🔥 1980万', change: 'down' },
  { rank: 6, title: '间谍过家家 第三季', type: '日漫', hot: '🔥 1720万', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">热门排行榜</h2>
          <p className="mt-3 text-sm text-foreground-600">根据播放量与讨论热度实时更新，看看大家现在都在追什么</p>
        </div>
        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-2xl bg-background-50 border border-background-200/70 transition-all hover:-translate-x-1 cursor-pointer"
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-heading flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-950 truncate">{item.title}</p>
                <p className="text-xs text-foreground-500">{item.type}</p>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-600 whitespace-nowrap">{item.hot}</span>
                <span className={`text-xs ${
                  item.change === 'up' ? 'text-primary-500' :
                  item.change === 'down' ? 'text-foreground-400' :
                  'text-foreground-400'
                }`}>
                  <i className={`${item.change === 'up' ? 'ri-arrow-up-line' : item.change === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line'}`}></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}